import { OrganizationUnitType } from '@inplay/models';
import { OptionWithLoading } from '../../../pages/userManagement/userManagement.type';
import { OrgUnit, Venue } from '../../../utils/helper.type';
import { OrgUnitPresentation } from '../orgUnitPresentation.interface';
import {
  OrganizationUnitKey,
  VenuesViewKebabOptions,
  VenuesViewTableHeaderKey,
} from '../../../pages/userManagement/venuesView/venuesView.type';
import { VenuesViewTableColumns } from '../orgUnitPresentationTypes';
import { getOrganizationUnitsByTypeAndParent } from '../../../pages/userManagement/venuesView/venuesViewHelper';

export class VenuePresentationStrategy implements OrgUnitPresentation<Venue> {
  public unitTranslationKey = 'userManagement.venues';
  public orgUnitType = OrganizationUnitType.VENUE;

  getTableData(
    allOrgUnits: OrgUnit[],
    parentOrgUnitId: string | null,
  ): Venue[] {
    if (parentOrgUnitId) {
      return getOrganizationUnitsByTypeAndParent(
        allOrgUnits,
        OrganizationUnitType.VENUE,
        parentOrgUnitId,
      ) as Venue[];
    }

    const venues: Venue[] = allOrgUnits.filter(
      (orgUnit: OrgUnit) => orgUnit.type === OrganizationUnitType.VENUE,
    ) as Venue[];

    return venues;
  }

  getTableColumns(): VenuesViewTableColumns[] {
    return [
      {
        header: VenuesViewTableHeaderKey.VENUE_NAME,
        sortable: true,
        key: OrganizationUnitKey.NAME,
      },
      { header: VenuesViewTableHeaderKey.STATUS },
      { header: VenuesViewTableHeaderKey.ACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.INACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.VENUE_BRANCHES },
      { header: VenuesViewTableHeaderKey.ADDED_BY },
    ];
  }
  getKebabOptions(): OptionWithLoading<VenuesViewKebabOptions>[] {
    return [
      {
        loading: false,
        label: VenuesViewKebabOptions.EDIT_VENUE,
        value: VenuesViewKebabOptions.EDIT_VENUE,
      },
      {
        loading: false,
        label: VenuesViewKebabOptions.DELETE_VENUE,
        value: VenuesViewKebabOptions.DELETE_VENUE,
      },
    ];
  }
}
